var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex-grow-1 p-2"},[_c('TranslationsManager',{attrs:{"value":_vm.value,"empty-state-title":"Dit product heeft geen vertalingen"},on:{"input":newVal => _vm.$emit('input', newVal)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }